import { render, staticRenderFns } from "./Easy2.vue?vue&type=template&id=63ce120e&scoped=true"
import script from "./Easy2.vue?vue&type=script&lang=js"
export * from "./Easy2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce120e",
  null
  
)

export default component.exports